import React, {useEffect, useState, useRef} from 'react';
import intl from "react-intl-universal";


import {GetCollabDocResponse} from "@stores/serverConnection/types";
import type {ItemModelType} from "@stores/WorkspaceStore";
import {getDocumentInfo} from "../../../../actions/getDocumentInfo";
import {InfoBlockRow} from "../../../components/InfoBlockRow";


import './DocumentInfo.css';
import {useUserState} from "@stores/AppStateContext";


export interface DocumentInfoProps {
    item: ItemModelType;
}

export interface DocInfo {
    item: {
        creator: string,
        createdAt: string,
    },
    document: GetCollabDocResponse,
}

export const DocumentInfo = ({item}: DocumentInfoProps) => {
    const userState = useUserState();
    const [isDocInfoReady, setDocInfoIsReady] = useState(false);
    const infoRef = useRef<DocInfo | null>(null)

    useEffect(() => {
        getDocumentInfo(userState!.wsServerConnection, item).then((document) => {
            infoRef.current = {
                item: {
                    creator: item.creator,
                    createdAt: item.createdAt,
                },
                document
            }
            setDocInfoIsReady(true);
        });
    }, [item]);

    if (!isDocInfoReady) {
        return <div className="DocumentInfo">Loading...</div>
    }
    return (
        <div className="DocumentInfo">
            <div className="DocumentInfo__label body-medium">
                {intl.get('common.created').d('Created')}
            </div>
            <InfoBlockRow
                userId={infoRef.current!.item.creator}
                dateIso={infoRef.current!.item.createdAt!}
            />
            <div className="DocumentInfo__label body-medium">
                {intl.get('common.last_edited').d('Last edited')}
            </div>
            <InfoBlockRow
                userId={infoRef.current!.document.latestEditor}
                dateIso={infoRef.current!.document.updatedAt}
            />
        </div>
    )
}
